import React from 'react';
import { SectionWithCode } from 'Templates';
import * as code from '../StringCodes';

export const Installation = () => (
	<SectionWithCode
		readonly
		title='Installation(not publish yet)'
		code={`npm i draggerjs`}
		language='js'
		theme={{
			plain: {
				color: 'rgb(215,215,215)',
				backgroundColor: 'rgb(86,86,86)',
			},
			styles: [],
		}}
	/>
);

export const Importing = () => (
	<SectionWithCode readonly title='Imports' code={code.Importing} />
);